module.exports = __webpack_public_path__ + "static/media/FLOOR-LOGO.854d9159.png";